module.exports = __webpack_public_path__ + "img/project-37.66092a2d.png";